<template>
    <div class="content-wrapper">
        <loading :active.sync="processingAPI" :is-full-page="true" color="#28a745" loader="bars" />
        <div class="content-header">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-12">
                        <h1 class="m-0 bold">Loan Accounts</h1>
                    </div>

                </div>
            </div>
        </div>

        <div class="content">
            <div class="container-fluid">
                <div class="alert alert-info2 mb-2" role="alert" v-if="tester && !survey">
                    <span>Share your experience with the Statement of Account (SOA) and Billings feature of the Borrower Registry
                        System (BRS) with us! Through your feedback, we will be able to further improve this feature. <a href="javascript:void(0)" style="color:#007bff" @click="showSurvey">Proceed with the survey</a>
                    </span>
                </div>

                <div class="row" v-if="cans.length==0">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-body">
                                <div class="alert alert-info2 mb-0" role="alert">
                                    <i class="fas fa-info-circle fs-25 mr-1"></i><span class="fs-20">Your loan account details are being updated. Please come back at a later time.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row" v-if="cans.length">
                    <div class="col-lg-4 d-flex">
                        <div class="card flex-fill">
                            <div class="card-header">
                                <h5 class="card-title bold">Profile</h5>
                            </div>
                            <div class="card-body">
                                <div class="table-responsive">
                                    <table class="table table-sm">
                                        <tbody>
                                            <!-- style="background-color: #ffff00!important;" -->
                                            <tr style="background-color: #ffff00!important;">
                                                <td>Customer Account Number(CAN):</td>
                                                <td>
                                                    <v-select style="font-size:19px!important;" @input="getBorrowerDetails(can)" append-to-body class="text-uppercase bold" :options="cans" :reduce="can => can.can" label="can" v-model="can" :clearable="false" placeholder="- Select -"></v-select>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>PN Number:</td>
                                                <td><b>{{profile.pnno}}</b></td>

                                            </tr>
                                            <!-- <tr>
                                                <td>Borrower Name:</td>
                                                <td><b>{{profile.borrower_name}}</b></td>
                                            </tr> -->
                                            <tr>
                                                <td>Business Name:</td>
                                                <td><b>{{profile.business_name}}</b></td>
                                            </tr>
                                            <tr>
                                                <td>Loan Amount:</td>
                                                <td><b>{{profile.relamt | accounting}}</b></td>
                                            </tr>
                                            <tr>
                                                <td>Loan Term <small>(Inclusive of Grace Period)</small></td>
                                                <td><b>{{profile.term}}</b></td>
                                            </tr>
                                            <tr>
                                                <td>Grace Period:</td>
                                                <td><b>{{profile.gp}}</b></td>
                                            </tr>
                                            <tr>
                                                <td>Maturity:</td>
                                                <td><b>{{profile.maturity | date_aps}}</b></td>
                                            </tr>
                                            <tr>
                                                <td>Release Date:</td>
                                                <td><b>{{profile.daterel | date_aps}}</b></td>
                                            </tr>
                                            <tr>
                                                <td>Interest Rate:</td>
                                                <td><b>{{profile.rate}}%</b></td>
                                            </tr>
                                            <tr>
                                                <td>Penalty Rate:</td>
                                                <td><b>{{profile.penalty_rate}}%</b></td>
                                            </tr>
                                            <tr>
                                                <td>Service Fee Rate:</td>
                                                <td><b>{{profile.service_fee_rate}}%</b></td>
                                            </tr>
                                            <tr>
                                                <td>Payment Mode:</td>
                                                <td><b>{{profile.paymode}}</b></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-8 d-flex" v-if="tester">
                        <div class="card flex-fill">
                            <div class="card-header">
                                <h5 class="card-title bold">Account Detail</h5>
                            </div>
                            <div class="card-body">
                                <div class="row mb-2">
                                    <div class="col-12">
                                        <div class="float-right">
                                            <button type="button" class="btn btn-outline-primary btn-sm">Refresh<i class="fas fa-sync ml-1"></i></button>
                                        </div>
                                    </div>
                                </div>

                                <div class="card card-primary card-outline card-outline-tabs" style="min-height: 325px;">
                                    <div class="card-header p-0 border-bottom-0">
                                        <ul class="nav nav-tabs nav-fill" id="custom-tabs-four-tab" role="tablist">
                                            <li class="nav-item">
                                                <a class="nav-link active" id="tab1-tab" data-toggle="pill" href="#tab1" role="tab" aria-controls="tab1" aria-selected="true" @click="selectedTab1"> <i class="fas fa-file-invoice-dollar mr-1"></i>Billings</a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link" id="tab2-tab" data-toggle="pill" href="#tab2" role="tab" aria-controls="tab2" aria-selected="false" @click="selectedTab2"> <i class="fas fa-file-invoice mr-1"></i>Statement of Account</a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link" id="tab3-tab" data-toggle="pill" href="#tab3" role="tab" aria-controls="tab3" aria-selected="false" @click="selectedTab3"><i class="fas fa-history mr-1"></i>Payment History</a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link" id="tab4-tab" data-toggle="pill" href="#tab4" role="tab" aria-controls="tab4" aria-selected="false" @click="selectedTab4"><i class="fas fa-file-invoice mr-1"></i>Contractual Amortization</a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="card-body">
                                        <div class="tab-content" id="custom-tabs-four-tabContent">

                                            <div class="tab-pane fade active show" id="tab1" role="tabpanel" aria-labelledby="tab1-tab">
                                                <section v-if="tab1">
                                                    <data-table :tblName="'user-lists'" :title="'Billing Statement'" :columns="columns" :sortKey="sortKey" :sortOrders="sortOrders" @sort="sortBy" :pagination="pagination" @prev="getApsDetails(pagination.prevPageUrl)" @next="getApsDetails(pagination.nextPageUrl)">
                                                        <template v-slot:th>
                                                            <th class="d-print-none" width="5%">Show</th>
                                                        </template>

                                                        <template v-slot:tbody>
                                                            <tbody>
                                                                <tr v-for="(i, index) in billing" :key="index">
                                                                    <td class="nowarp align-middle">{{i.bill_date | MM/DD/YYYY}}</td>
                                                                    <td class="nowarp align-middle">{{i.pnno}}</td>
                                                                    <td class="nowarp align-middle">{{i.can}}</td>
                                                                    <td class="nowarp align-middle text-right">{{i.amount_due | accounting}}</td>
                                                                    <td class="nowarp align-middle">{{i.duedate | MM/DD/YYYY}}</td>

                                                                    <td class="nowrap align-middle">
                                                                        <button class="btn btn-outline-primary btn-sm my-1" @click="genBilingPDF(i.pnno, i.borrower_id, i.duedate, i.bill_date)">
                                                                            <i class="fas fa-file-invoice-dollar mr-1"></i>Billing Statement
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                                <tr v-if="billing.length == 0">
                                                                    <td colspan="6" class="text-center">No records found</td>
                                                                </tr>
                                                            </tbody>
                                                        </template>

                                                        <template v-slot:rows class="no-print">
                                                            <span>Rows per page:</span>
                                                            <select class="form-control custom-select-sm ml-1" v-model="tableData.length" @change="getApsDetails()" style="width: 65px !important;">
                                                                <option v-for="(r, index) in rows" :key="index" :value="r">{{r}}</option>
                                                            </select>
                                                        </template>
                                                    </data-table>
                                                </section>
                                            </div>


                                            <div class="tab-pane fade" id="tab2" role="tabpanel" aria-labelledby="tab2-tab">
                                                <div v-if="tab2">
                                                    <div class="table-responsive ">
                                                        <table class="table table-bordered table-sm fs-15">
                                                            <thead>
                                                                <tr class="text-center">
                                                                    <th class="align-middle" rowspan="2" colspan="1">
                                                                        Period
                                                                    </th>
                                                                    <th class="align-middle" rowspan="2" colspan="1">
                                                                        Due Date
                                                                    </th>
                                                                    <th class="align-middle" rowspan="2" colspan="1">
                                                                        Total Amount Due
                                                                    </th>
                                                                    <th class="align-middle" rowspan="2" colspan="1">
                                                                        Total Payments
                                                                    </th>
                                                                    <th class="align-middle" rowspan="2" colspan="1">
                                                                        OR Number
                                                                    </th>
                                                                    <th class="align-middle" rowspan="2" colspan="1">
                                                                        Payment Date
                                                                    </th>

                                                                    <th class="align-middle" rowspan="1" colspan="2">
                                                                        Penalty
                                                                    </th>
                                                                    <th class="align-middle" rowspan="1" colspan="2">
                                                                        Interest
                                                                    </th>
                                                                    <th class="align-middle" rowspan="1" colspan="2">
                                                                        Principal
                                                                    </th>
                                                                    <th class="align-middle" rowspan="2" colspan="1">
                                                                        Total Outstanding Balance
                                                                    </th>
                                                                </tr>
                                                                <tr class="align-middle text-center">
                                                                    <th>Change</th>
                                                                    <th>Outstanding</th>
                                                                    <th>Change</th>
                                                                    <th>Outstanding</th>
                                                                    <th>Change</th>
                                                                    <th>Outstanding</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(i, index) in soa" :key="index" class="nowrap align-middle" v-if="i.period !='Beginning'">
                                                                    <td class="text-center">{{i.period}}</td>
                                                                    <td class="text-center">{{i.duedate | date_aps}}</td>
                                                                    <td class="text-center">{{i.amount_due | accounting}}</td>
                                                                    <!-- <td class="text-right"><a href="javascript:void(0)" @click="getAmountDue(i.pnno, i.period, index)">{{i.amount_due | accounting}}</a></td> -->
                                                                    <td class="text-right"><a href="javascript:void(0)" @click="getTotalPayment(i.pnno, i.period)">{{i.total_payment | accounting}}</a></td>
                                                                    <td class="text-center">{{i.orno}}</td>
                                                                    <td class="text-center">{{i.payment_date | date_aps}}</td>
                                                                    <td class="text-center">{{i.penalty_net_change | accounting}}</td>
                                                                    <td class="text-center">{{i.penalty_outstanding | accounting}}</td>
                                                                    <!-- <td class="text-right"><a href="javascript:void(0)" @click="getPenalty(i.pnno, i.period, i.bill_date)">{{i.penalty_outstanding | accounting}}</a></td> -->
                                                                    <td class="text-center">{{i.interest_net_change | accounting}}</td>
                                                                    <td class="text-center">{{i.interest_outstanding | accounting}}</td>
                                                                    <!-- <td class="text-right"><a href="javascript:void(0)" @click="getInterest(i.pnno, i.period)">{{i.interest_outstanding | accounting}}</a></td> -->
                                                                    <td class="text-center">{{i.principal_net_change | accounting}}</td>
                                                                    <td class="text-right">{{i.running_ob | accounting}}</td>
                                                                    <td class="text-right">{{i.total_outstanding | accounting}}</td>
                                                                </tr>
                                                                <tr v-if="soa.length == 0">
                                                                    <td colspan="14" class="text-center">No records found</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div class="alert alert-info2 mt-2" role="alert">
                                                        <b>DISCLAIMER:</b> The information provided in your Billing Statement is not yet final and is subject to change. For inquiries or concerns about your Billing Statement, please
                                                        contact us at SBCorp Hotline <b>8651-3333</b> or <b>1-800-10-651-3333</b> (nationwide toll-free), or email us at <b>sbcorporation@sbcorp.gov.ph</b>.
                                                    </div>

                                                </div>
                                            </div>

                                            <div class="tab-pane fade" id="tab3" role="tabpanel" aria-labelledby="tab3-tab">
                                                <div v-if="tab3">
                                                    <div class="table-responsive tableFixHead">
                                                        <table class="table table-bordered table-sm fs-15">
                                                            <thead>
                                                                <tr class="align-middle text-center">
                                                                    <th>Payment Date</th>
                                                                    <th>Payment Type</th>
                                                                    <th>Amount Paid</th>
                                                                    <th>Official Receipt Number</th>
                                                                    <th>Official Receipt Date</th>
                                                                    <th>Status</th>
                                                                    <th>Payment Channel</th>
                                                                    <th>Transaction No.</th>
                                                                </tr>

                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(i, index) in payment_history" :key="index">
                                                                    <td class="nowrap align-middle text-center">{{i.payment_date | date_aps}}</td>
                                                                    <td class="nowrap align-middle text-center">{{i.paykind}}</td>
                                                                    <td class="nowrap align-middle text-right">
                                                                        {{i.oramount | accounting}}
                                                                    </td>
                                                                    <td class="nowrap align-middle text-center">{{i.orno}}</td>
                                                                    <td class="nowrap align-middle text-center">{{i.ordate | date_aps}}</td>
                                                                    <td class="nowrap align-middle text-center">{{i.aps_status}}</td>
                                                                    <td class="nowrap align-middle text-center">{{i.payment_channel}}</td>
                                                                    <td class="nowrap align-middle text-center">{{i.trans_no}}</td>
                                                                </tr>
                                                                <tr v-if="payment_history.length == 0">
                                                                    <td colspan="8" class="text-center">No records found</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>

                                                    </div>
                                                </div>
                                            </div>

                                            <div class="tab-pane fade" id="tab4" role="tabpanel" aria-labelledby="tab4-tab">
                                                <div v-if="tab4">
                                                    <div class="table-responsive tableFixHead">
                                                        <table class="table table-bordered table-sm fs-15">
                                                            <thead>
                                                                <tr class="align-middle text-center">
                                                                    <th>PERIOD</th>
                                                                    <th>DUE DATE</th>
                                                                    <th>PRINCIPAL</th>
                                                                    <th>INTEREST</th>
                                                                    <th>TOTAL AMORTIZATION DUE</th>
                                                                    <th>OUTSTANDING BALANCE</th>
                                                                </tr>

                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(i, index) in amort" :key="index">
                                                                    <td class="nowrap align-middle text-center">{{i.period}}</td>
                                                                    <td class="nowrap align-middle text-center">{{i.duedate | date_aps}}</td>
                                                                    <td class="nowrap align-middle text-right">
                                                                        {{i.principal | accounting}}
                                                                    </td>
                                                                    <td class="nowrap align-middle text-right">
                                                                        {{i.interest | accounting}}
                                                                    </td>
                                                                    <td class="nowrap align-middle text-right">
                                                                        {{i.total | accounting}}
                                                                    </td>
                                                                    <td class="nowrap align-middle text-right">
                                                                        {{i.outsbalance | accounting}}
                                                                    </td>
                                                                </tr>
                                                                <tr v-if="amort.length == 0">
                                                                    <td colspan="6" class="text-center">No records found</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>




                </div>
                <!-- /.row -->

                <div class="modal fade" id="modalBill" role="dialog" data-backdrop="static" data-keyboard="false">
                    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title bold">Billing Statement</h5>
                            </div>
                            <div class="modal-body" v-if='viewPDF'>
                                <object :data="fileURL + '#view=FitH'" type="application/pdf" internalinstanceid="9" title="PDF" width="100%" height="678" id='pdf_file'>
                                    <div class="alert alert-warning2" role="alert">
                                        <span>Your browser isn't supporting embedded pdf files. You can download the file.</span>
                                    </div>
                                </object>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-outline-primary btn-sm mr-auto" @click='closeModalBill'>Close</button>
                                <button type="button" class="btn btn-primary btn-sm" @click='printPDF'><i class="fas fa-print mr-1"></i>Print</button>
                                <button type="button" class="btn btn-primary btn-sm" @click='downloadPDF'><i class="fas fa-download mr-1"></i>Download</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal fade" id="modalTotalPayment" role="dialog" data-backdrop="static" data-keyboard="false">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title bold">Total Payment Computation</h5>
                            </div>

                            <div class="modal-body">
                                <div class="col-12">
                                    <div class="table-responsive">
                                        <table class="table table-sm table-borderless">
                                            <tbody class="nowrap">
                                                <tr>
                                                    <td class="b-border" colspan="3">Payment Amount</td>
                                                    <td class="b-border text-right">{{total_payment.oramount | accounting}}</td>
                                                </tr>
                                                <tr>
                                                    <td colspan="2">Less: Applied to Penalty</td>
                                                    <td class="text-right">{{total_payment.penalty_payment | accounting}}</td>
                                                    <td class="text-right"></td>
                                                </tr>
                                                <tr>
                                                    <td colspan="2"><span style="padding-left:38px;">Applied to Interest</span></td>
                                                    <td class="text-right">{{total_payment.interest_payment | accounting}}</td>
                                                    <td class="text-right">{{total_payment.total_penalty | accounting}}</td>
                                                </tr>
                                                <tr>
                                                    <td class="bold t-border" colspan="3">Applied to Principal</td>
                                                    <td class="text-right bold t-border">{{total_payment.principal_payment | accounting}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-outline-primary btn-sm" data-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="modal fade" id="modalSurvey" role="dialog" data-backdrop="static" data-keyboard="false">
                    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title bold">SATISFACTION SURVEY</h5>
                            </div>

                            <div class="modal-body">
                                <div class="mx-4">
                                    <p class="text-center mb-0">Please rate your satisfaction with the Statement of Account (SOA) and Billings feature of the Borrower Registry System (BRS):</p>
                                    <p class="text-center font-italic">Punan ng katumbas na rating ang mga sumusunod patungkol sa inyong kasiyahan sa Statement of Account (SOA) at Billings feature ng Borrower Registry System (BRS):</p>
                                </div>
                                <div class="col-12">
                                    <a href="javascript:void(0)" ref="validation"></a>
                                    <div class="alert alert-danger2 alert-dismissible mb-2" v-if="$v.criteria.$error && submitting">
                                        <button type="button" class="close mt-n1" @click="submitting=false">&times;</button>
                                        <i class="fas fa-exclamation-circle mr-1"></i>Please fill out the <b>required field/s</b>.
                                    </div>

                                    <div class="table-responsive">
                                        <table class="table table-sm table-bordered">
                                            <thead>
                                                <tr class="text-center">
                                                    <th class="align-middle">Criteria</th>
                                                    <th class="align-middle">Question</th>
                                                    <th class="align-middle">
                                                        <p class="mb-0">Very difficult</p><em>(Labis na mahirap)</em>
                                                    </th>
                                                    <th class="align-middle">
                                                        <p class="mb-0">Somewhat difficult</p><em>(Mahirap)</em>
                                                    </th>
                                                    <th class="align-middle">Neutral</th>
                                                    <th class="align-middle">
                                                        <p class="mb-0">Somewhat easy</p><em>(Madali)</em>
                                                    </th>
                                                    <th class="align-middle">
                                                        <p class="mb-0">Very easy</p><em>(Labis na madali)</em>
                                                    </th>
                                                </tr>

                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td class="align-middle">
                                                        <p class="mb-0 text-nowrap">User-friendliness</p>
                                                        <i>Kadalian sa paggamit</i>
                                                    </td>
                                                    <td style="min-width: 350px;">
                                                        <ul style="list-style-type:none" class="ml-n3">
                                                            <li>1. How do you rate the ease of use of the SOA/Billings feature in the BRS?</li>
                                                            <li><i>Paano mo ire-rate ang kadalian sa paggamit ng SOA/Billings feature ng BRS?</i></li>
                                                            <li v-if="$v.criteria.c1.$error"><small class="danger">This field is required</small></li>
                                                        </ul>
                                                    </td>
                                                    <td class="align-middle text-center"><input type="radio" v-model="criteria.c1" :value="1" /></td>
                                                    <td class="align-middle text-center"><input type="radio" v-model="criteria.c1" :value="2" /></td>
                                                    <td class="align-middle text-center"><input type="radio" v-model="criteria.c1" :value="3" /></td>
                                                    <td class="align-middle text-center"><input type="radio" v-model="criteria.c1" :value="4" /></td>
                                                    <td class="align-middle text-center"><input type="radio" v-model="criteria.c1" :value="5" /></td>
                                                </tr>

                                                <tr>
                                                    <td class="align-middle">
                                                        <p class="mb-0 text-nowrap">Readability</p>
                                                        <i>Kadaliang basahin</i>
                                                    </td>
                                                    <td style="min-width: 350px;">
                                                        <ul style="list-style-type:none" class="ml-n3">
                                                            <li>2. How easy/difficult is it to <u><b>read</b></u> the contents of the SOA?</li>
                                                            <li><i>Gaano kadali/kahirap <u><b>mabasa</b></u> ang nilalaman ng SOA?</i></li>
                                                            <li v-if="$v.criteria.c2.$error"><small class="danger">This field is required</small></li>
                                                        </ul>
                                                    </td>
                                                    <td class="align-middle text-center"><input type="radio" v-model="criteria.c2" :value="1" /></td>
                                                    <td class="align-middle text-center"><input type="radio" v-model="criteria.c2" :value="2" /></td>
                                                    <td class="align-middle text-center"><input type="radio" v-model="criteria.c2" :value="3" /></td>
                                                    <td class="align-middle text-center"><input type="radio" v-model="criteria.c2" :value="4" /></td>
                                                    <td class="align-middle text-center"><input type="radio" v-model="criteria.c2" :value="5" /></td>
                                                </tr>

                                                <tr>
                                                    <td class="align-middle">
                                                        <p class="mb-0 text-nowrap">Comprehensibility</p>
                                                        <i>Kadaliang intindihin</i>
                                                    </td>
                                                    <td style="min-width: 350px;">
                                                        <ul style="list-style-type:none" class="ml-n3">
                                                            <li>3. How easy/difficult is it to <u><b>understand</b></u> the contents of the SOA?</li>
                                                            <li><i>Gaano kadali/kahirap <u><b>intindihin</b></u> ang nilalaman ng SOA?</i></li>
                                                            <li v-if="$v.criteria.c3.$error"><small class="danger">This field is required</small></li>
                                                        </ul>
                                                    </td>
                                                    <td class="align-middle text-center"><input type="radio" v-model="criteria.c3" :value="1" /></td>
                                                    <td class="align-middle text-center"><input type="radio" v-model="criteria.c3" :value="2" /></td>
                                                    <td class="align-middle text-center"><input type="radio" v-model="criteria.c3" :value="3" /></td>
                                                    <td class="align-middle text-center"><input type="radio" v-model="criteria.c3" :value="4" /></td>
                                                    <td class="align-middle text-center"><input type="radio" v-model="criteria.c3" :value="5" /></td>
                                                </tr>

                                                <tr>
                                                    <td class="align-middle">
                                                        <p class="mb-0 text-nowrap">Usefulness of content</p>
                                                        <i>Pagiging kapaki-pakinabang ng nilalaman</i>
                                                    </td>
                                                    <td style="min-width: 350px;">
                                                        <ul style="list-style-type:none" class="ml-n3">
                                                            <li>4. How satisfied are you with the <u><b>contents</b></u> of the SOA/Billings feature of the BRS <u><b>in terms of usefulness</b></u>?</li>
                                                            <li><i>Gaano ka nasisiyahan sa mga nilalaman ng SOA/Billings feature ng BRS?</i></li>
                                                            <li v-if="$v.criteria.c4.$error"><small class="danger">This field is required</small></li>
                                                        </ul>
                                                    </td>
                                                    <td class="align-middle text-center"><input type="radio" v-model="criteria.c4" :value="1" /></td>
                                                    <td class="align-middle text-center"><input type="radio" v-model="criteria.c4" :value="2" /></td>
                                                    <td class="align-middle text-center"><input type="radio" v-model="criteria.c4" :value="3" /></td>
                                                    <td class="align-middle text-center"><input type="radio" v-model="criteria.c4" :value="4" /></td>
                                                    <td class="align-middle text-center"><input type="radio" v-model="criteria.c4" :value="5" /></td>
                                                </tr>

                                                <tr>
                                                    <td class="align-middle">
                                                        <p class="mb-0 text-nowrap">Overall helpfulness</p>
                                                        <i>Kabuuang tulong</i>
                                                    </td>
                                                    <td style="min-width: 350px;">
                                                        <ul style="list-style-type:none" class="ml-n3">
                                                            <li>5. How satisfied are you with the overall helpfulness of the SOA/Billings feature of the BRS?</li>
                                                            <li><i>Gaano ka nasisiyahan sa kabuuang tulong na naibibigay ng SOA/Billings feature ng BRS?</i></li>
                                                            <li v-if="$v.criteria.c5.$error"><small class="danger">This field is required</small></li>
                                                        </ul>
                                                    </td>
                                                    <td class="align-middle text-center"><input type="radio" v-model="criteria.c5" :value="1" /></td>
                                                    <td class="align-middle text-center"><input type="radio" v-model="criteria.c5" :value="2" /></td>
                                                    <td class="align-middle text-center"><input type="radio" v-model="criteria.c5" :value="3" /></td>
                                                    <td class="align-middle text-center"><input type="radio" v-model="criteria.c5" :value="4" /></td>
                                                    <td class="align-middle text-center"><input type="radio" v-model="criteria.c5" :value="5" /></td>
                                                </tr>

                                                <tr>
                                                    <td class="align-middle">
                                                        <p class="mb-0 text-nowrap">Intent to recommend</p>
                                                        <i>Intensyon sa pagrekomenda</i>
                                                    </td>
                                                    <td style="min-width: 350px;">
                                                        <ul style="list-style-type:none" class="ml-n3">
                                                            <li>6. How likely are you going to recommend to other SB Corporation borrowers the SOA/Billings feature of the BRS?</li>
                                                            <li><i>Gaano kalamang na irerekomenda mo ang SOA/Billings feature ng BRS sa iba pang mga kliyente ng SB Corporation?</i></li>
                                                            <li v-if="$v.criteria.c6.$error"><small class="danger">This field is required</small></li>
                                                        </ul>
                                                    </td>
                                                    <td class="align-middle text-center"><input type="radio" v-model="criteria.c6" :value="1" /></td>
                                                    <td class="align-middle text-center"><input type="radio" v-model="criteria.c6" :value="2" /></td>
                                                    <td class="align-middle text-center"><input type="radio" v-model="criteria.c6" :value="3" /></td>
                                                    <td class="align-middle text-center"><input type="radio" v-model="criteria.c6" :value="4" /></td>
                                                    <td class="align-middle text-center"><input type="radio" v-model="criteria.c6" :value="5" /></td>
                                                </tr>

                                                <tr>
                                                    <td class="align-middle text-center bold">Criteria</td>
                                                    <td style="min-width: 350px;" class="text-center bold">Question</td>
                                                    <td class="align-middle text-center bold" colspan="5">Comment/s (if any)</td>
                                                </tr>

                                                <tr>
                                                    <td class="align-middle">
                                                        <p class="mb-0 text-nowrap">Suggestions</p>
                                                        <i>Mga mungkahi</i>
                                                    </td>
                                                    <td style="min-width: 350px;">
                                                        <ul style="list-style-type:none" class="ml-n3">
                                                            <li>7. What can we add in the SOA/Billings feature to make it more useful to you?</li>
                                                            <li><i>Ano ang maaari naming idagdag sa SOA/Billings feature upang mas maging kapaki-pakinabang ito sa iyo?</i></li>
                                                        </ul>
                                                    </td>
                                                    <td colspan="5" class="align-middle text-center"><textarea class="form-control" rows="5" v-model="criteria.c7"></textarea></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-outline-primary btn-sm" data-dismiss="modal">Cancel</button>
                                <button type="button" class="btn btn-primary btn-sm" @click="submitSurvey">Submit</button>
                            </div>
                        </div>
                    </div>
                </div>

            </div><!-- /.container-fluid -->
        </div>
        <!-- /.content -->

    </div>

</template>

<script>
    import moment from 'moment';
    import {
        required
    } from 'vuelidate/lib/validators';
    export default {
        components: {

        },
        data() {
            let sortOrders = {};
            let columns = [{
                    // width: '23%',
                    label: 'Billing Date',
                    name: 'bill_date',
                    show: true,
                },
                {
                    // width: '22%',
                    label: 'PN Number',
                    name: 'pnno',
                    show: true,

                },
                {
                    // width: '22%',
                    label: 'CAN',
                    name: 'can',
                    show: true,

                },
                {
                    // width: '22%',
                    label: 'Amount Due',
                    name: 'amount_due',
                    show: true,
                },
                {
                    // width: '22%',
                    label: 'Due Date',
                    name: 'duedate',
                    show: true,
                },
            ];

            let column_names = columns.map(a => a.name);

            columns.forEach((column) => {
                sortOrders[column.name] = -1;
            });

            return {
                submitting: false,
                criteria: {
                    c1: '',
                    c2: '',
                    c3: '',
                    c4: '',
                    c5: '',
                    c6: '',
                    c7: '',
                },

                can: '',
                cans: [],
                profile: {},
                survey: false,
                tester: false,
                api: {
                    loader: false,
                    counter: false,
                    profile: false,

                    soa: false,
                    bill: false,
                    pay_hist: false,
                    amort: false,
                    pn: false,
                    amount_due: false,
                    penalty: false,
                    tester: false
                },
                showProfile: true,
                formPenalty: {},
                show_penalty_beginning_bal: false,
                profile: {},
                sub_penalty: 0,
                penalty_beginning_bal: [],
                amount_due: {},
                total_payment: {},
                penalty: {},
                interest: {},

                num: null,
                payment_history: [],
                amort: [],
                billing: [],
                fileURL: null,
                viewPDF: false,
                soa: [],
                view: false,

                tab1: true,
                tab2: false,
                tab3: false,
                tab4: false,

                payLoading: false,
                tableLoading: false,

                pnno: this.$route.query.pnno,
                borrower_id: this.$route.query.borrower_id,
                borrower_name: this.$route.query.borrower_name,
                business_name: this.$route.query.business_name,
                can: this.$route.query.can,


                columns: columns,
                sortKey: 'bill_date',
                sortOrders: sortOrders,
                rows: [10, 50, 100],

                filterLength: 10,
                tableData: {
                    length: 10,
                    search: '',
                    column: 0,
                    dir: 'desc',

                    pnno: '',
                    column_names: column_names,
                },
                pagination: {
                    lastPage: '',
                    currentPage: '',
                    total: 0,
                    lastPageUrl: '',
                    nextPageUrl: '',
                    prevPageUrl: '',
                    from: 0,
                    to: 0
                },
            }
        },

        validations: {
            criteria: {
                c1: {
                    required
                },
                c2: {
                    required
                },
                c3: {
                    required
                },
                c4: {
                    required
                },
                c5: {
                    required
                },
                c6: {
                    required
                },
            },
        },

        created() {
            this.getCans();
            this.apsCounter();
        },
        computed: {
            processingAPI() {
                return Object.values(this.api).includes(true);
            }
        },

        methods: {

            submitSurvey() {
                this.submitting = true;
                this.$v.criteria.$touch();
                if (this.$v.criteria.$invalid) {
                    this.$refs.validation.focus();
                    alert(false)

                } else {
                    this.submitting = false;
                    this.api.loader = true;
                    axios.post('/api/post-aps-survey', this.criteria)
                        .then(res => {
                            $('#modalSurvey').modal('hide');

                            this.survey = res.data.survey;
                            this.api.loader = false;

                            Swal.fire({
                                icon: "success",
                                title: "Thank You!",
                                text: "Submitted successfully",
                                allowOutsideClick: false,
                            }).then((response) => {});
                        }).catch(err => {
                            this.api.loader = false;
                        })
                }
            },
            showSurvey() {
                $('#modalSurvey').modal('show');
            },


            closeModalBill() {
                this.viewPDF = false;
                $('#modalBill').modal('hide');
            },

            downloadPDF: _.debounce(function() {
                let filename = 'SBC-Billing-Statement' + '.pdf';
                const link = document.createElement('a');
                link.href = this.fileURL;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                link.remove();
            }, 333),

            printPDF: _.debounce(function() {
                var iframe = document.createElement('iframe');
                iframe.className = 'pdfIframe'
                document.body.appendChild(iframe);
                iframe.style.display = 'none';
                iframe.onload = function() {
                    setTimeout(function() {
                        iframe.focus();
                        iframe.contentWindow.print();
                    }, 100);
                };
                iframe.src = this.fileURL;
            }, 333),

            genBilingPDF(pnno, borrower_id, duedate, bill_date) {
                this.api.loader = true;
                axios.get('/api/generate-billing-pdf', {
                        params: {
                            pnno: pnno,
                            borrower_id: borrower_id,
                            duedate: duedate,
                            bill_date: bill_date,
                        },
                        responseType: 'blob'
                    })
                    .then(response => {
                        this.fileURL = window.URL.createObjectURL(response.data);
                        this.viewPDF = true;
                        $('#modalBill').modal('show');
                        this.api.loader = false;
                    })
                    .catch(error => {
                        this.api.loader = false;
                        console.log(error);
                    })
            },


            getAmort(pnno) {
                this.api.amort = true;
                axios.get('/api/get-amort', {
                        params: {
                            pnno: pnno
                        }
                    })
                    .then(response => {
                        this.amort = [];
                        this.amort = response.data.data;
                        this.api.amort = false;
                    })
                    .catch((error) => {
                        console.log(error);
                        this.api.amort = false;
                    })
            },

            getPaymentHistory(pnno) {
                this.api.pay_hist = true;
                axios.get('/api/get-payment-history', {
                        params: {
                            pnno: pnno
                        }
                    })
                    .then(response => {
                        this.payment_history = [];
                        this.payment_history = response.data.data;
                        this.api.pay_hist = false;
                    })
                    .catch((error) => {
                        console.log(error);
                        this.api.pay_hist = false;
                    })
            },

            getTotalPayment(pnno, period) {
                this.total_payment = {};
                this.api.loader = true;
                axios.get('/api/soa-total-payment', {
                        params: {
                            pnno: pnno,
                            period: period,
                        }
                    })
                    .then(response => {
                        this.total_payment = response.data.data;
                        $('#modalTotalPayment').modal('show');
                        this.api.loader = false;
                    })
                    .catch((error) => {
                        console.log(error);
                        this.api.loader = false;
                    })
            },
            getSOA(pnno) {
                this.api.soa = true;
                axios.get('/api/get-soa', {
                        params: {
                            pnno: pnno
                        }
                    })
                    .then(response => {
                        this.soa = [];
                        this.soa = response.data.soa;
                        this.api.soa = false;
                    })
                    .catch((error) => {
                        console.log(error);
                        this.api.soa = false;
                    })
            },
            getApsDetails(url = '/api/get-aps-details') {
                if (this.profile.pnno) {
                    this.api.pn = true;
                    axios.get(url, {
                            params: this.tableData
                        })
                        .then(response => {
                            let data = response.data;
                            this.billing = data.data.data;
                            this.configPagination(data.data);
                            this.api.pn = false;
                        })
                        .catch((error) => {
                            this.api.pn = false;
                            console.log(error);
                        })
                }
            },

            selectedTab1() {
                this.tab1 = true;
                this.getApsDetails();
            },
            selectedTab2() {
                this.tab2 = true;
                this.getSOA(this.profile.pnno)
            },
            selectedTab3() {
                this.tab3 = true;
                this.getPaymentHistory(this.profile.pnno)
            },
            selectedTab4() {
                this.tab4 = true;
                this.getAmort(this.profile.pnno)
            },

            // table pagination and sorting
            resetPagination() {
                this.pagination.currentPage = 1;
                this.pagination.nextPageUrl = '';
                this.pagination.prevPageUrl = '';
            },
            configPagination(data) {
                this.pagination.lastPage = data.last_page;
                this.pagination.currentPage = data.current_page;
                this.pagination.total = data.total;
                this.pagination.lastPageUrl = data.last_page_url;
                this.pagination.nextPageUrl = data.next_page_url;
                this.pagination.prevPageUrl = data.prev_page_url;
                this.pagination.from = data.from;
                this.pagination.to = data.to;
            },
            sortBy(key) {
                this.sortKey = key;
                this.sortOrders[key] = this.sortOrders[key] * -1;
                this.tableData.column = this.getIndex(this.columns, 'name', key);
                this.tableData.dir = this.sortOrders[key] === 1 ? 'asc' : 'desc';
                this.getApsDetails();
            },
            getIndex(array, key, value) {
                return array.findIndex(i => i[key] == value)
            },

            apsCounter() {
                this.api.counter = true;
                axios.post('/api/aps-counter')
                    .then(response => {
                        this.api.counter = false;
                    })
                    .catch((error) => {
                        this.api.counter = false;
                        console.log(error);
                    })
            },
            getCans() {
                this.api.loader = true;
                axios.get('/api/get-aps-can')
                    .then(response => {
                        this.cans = response.data.data;
                        if (this.cans.length) {
                            this.can = this.cans[0].can;
                            this.getBorrowerDetails(this.can);
                        }
                        this.api.loader = false;
                    })
                    .catch((error) => {
                        this.api.loader = false;
                    })
            },
            getBorrowerDetails(can) {
                this.api.profile = true;
                axios.get('/api/get-aps-bor-profile', {
                        params: {
                            can: can,
                        }
                    })
                    .then(response => {
                        this.profile = response.data.data;
                        this.tableData.pnno = this.profile.pnno;

                        if (this.profile) {
                            // this.getTester();
                        }
                        this.api.profile = false;
                    })
                    .catch((error) => {
                        this.api.profile = false;
                    })
            },

            getTester() {
                this.api.tester = true;
                axios.get('/api/get-aps-tester')
                    .then(response => {
                        let tester = response.data.tester
                        this.survey = response.data.survey;
                        if (tester == 1) {
                            this.tester = true;
                            this.tab1 = true;
                            $('#tab1-tab').tab('show');
                            this.getApsDetails();
                        }
                        this.api.tester = false;
                    })
                    .catch((error) => {
                        this.api.tester = false;
                    })
            },

        },
    }
</script>

<style scoped>
    td.min {
        width: 1%;
        white-space: nowrap;
    }

    .tableFixHead thead th {
        position: -webkit-sticky;
        position: sticky;
        top: -1px;
        background-color: #fff;
    }

    .tableFixHead th:after,
    .tableFixHead th:before {
        content: '';
        position: absolute;
        left: 0;
        width: 100%;
    }

    .tableFixHead th:before {
        top: 0;
        border-top: 0.5px solid #edecec;
    }

    .tableFixHead th:after {
        bottom: 0;
        border-bottom: 0.5px solid #edecec;
    }


    .tableFixHead {
        overflow-y: auto !important;
        min-height: 200px !important;
        max-height: 500px !important;
    }

    .tableFixHead>table>thead tr:nth-child(1) th {
        background-color: white;
        position: sticky;
        position: -webkit-sticky;
        top: 0;
        z-index: 5;
        border-bottom: 4px solid white;
    }

    .tableFixHead>table>thead tr:nth-child(2) th {
        background-color: white;
        position: sticky;
        position: -webkit-sticky;
        top: 35px;
        border-top: 0;
        z-index: 5;
        border-top: 1px solid #dee2e6;
    }

    .tableFixHead>table>thead tr th:not(:first-child) {
        border-left: 0;
    }

    .tableFixHead>table>tbody tr td:not(:first-child) {
        border-left: 0;
    }

    .tableFixHead>table {
        border-collapse: separate;
        border-spacing: 0;
    }

    .tableFixHead>table>tbody>tr>td {
        border-top: 0;
    }

    .tableFixHead>table>thead tr th:nth-child(1) {
        top: 0;
        left: 0;
        position: sticky;
        z-index: 6;
    }

    .tableFixHead>table>thead>tr:nth-child(2) th:nth-child(1) {
        top: 35px;
        left: 0;
        position: sticky;
        z-index: 6;
    }

    .tableFixHead>table>tbody tr td:nth-child(1) {
        left: 0;
        position: sticky;
        background-color: inherit !important;
        z-index: 4;
    }

    .t-border {
        border-top: 1px solid #212529;
        border-bottom: double #212529;
    }

    .total-border {
        border-top: 1px solid #212529;
        border-bottom: double #212529;
        border-left: none;
        border-right: none;
    }

    .b-border {
        border-bottom: 1px solid #212529;
    }
</style>